import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, Activity, BarChart3, Shield, Settings } from 'lucide-react';
import { UserManagementTab } from './admin/UserManagement';
import { ActivityLogTab } from './admin/ActivityLog';
import { UsageDashboardTab } from './admin/UsageDashboard';
import { ExemptionsTab } from './admin/Exemptions';
import { SystemSettingsTab } from './admin/SystemSettings';
import { useTranslation } from '@/i18n/TranslationContext';
import { useAuth } from '@/lib/auth-context';

export default function AdminDashboard() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const isSuperAdmin = user?.role === 'super_admin';

  return (
    <div className="space-y-6 animate-fade-in" data-testid="admin-dashboard">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground">
          {isSuperAdmin ? 'Super Admin' : 'Admin'} Console
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          {t('manage_platform')}
        </p>
      </div>

      <Tabs defaultValue="users" className="space-y-4">
        <TabsList className="bg-muted/30 border border-border/60">
          <TabsTrigger value="users" data-testid="admin-tab-users" className="data-[state=active]:bg-accent/40">
            <Users className="mr-2 h-4 w-4" />Users
          </TabsTrigger>
          <TabsTrigger value="activity" data-testid="admin-tab-activity" className="data-[state=active]:bg-accent/40">
            <Activity className="mr-2 h-4 w-4" />Activity Log
          </TabsTrigger>
          <TabsTrigger value="usage" data-testid="admin-tab-usage" className="data-[state=active]:bg-accent/40">
            <BarChart3 className="mr-2 h-4 w-4" />Usage
          </TabsTrigger>
          {isSuperAdmin && (
            <TabsTrigger value="exemptions" data-testid="admin-tab-exemptions" className="data-[state=active]:bg-accent/40">
              <Shield className="mr-2 h-4 w-4" />Exemptions
            </TabsTrigger>
          )}
          {isSuperAdmin && (
            <TabsTrigger value="settings" data-testid="admin-tab-settings" className="data-[state=active]:bg-accent/40">
              <Settings className="mr-2 h-4 w-4" />System Settings
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="users"><UserManagementTab /></TabsContent>
        <TabsContent value="activity"><ActivityLogTab /></TabsContent>
        <TabsContent value="usage"><UsageDashboardTab /></TabsContent>
        {isSuperAdmin && <TabsContent value="exemptions"><ExemptionsTab /></TabsContent>}
        {isSuperAdmin && <TabsContent value="settings"><SystemSettingsTab /></TabsContent>}
      </Tabs>
    </div>
  );
}
